<template>
  <v-container fluid @mouseover="fab=true" @mouseleave="fab=false">
    <v-layout align-center justify-center>
      <slot name="translation"></slot>
      <v-speed-dial v-model="fab" absolute direction="left">
        <v-btn fab dark small color="blue" @click="$emit('editItem',item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn fab dark small color="pink" @click="$emit('deleteItem', item)">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </v-speed-dial>
    </v-layout>
  </v-container>
</template>

<script>
import ConfirmationDialog from "../../shared/ConfirmationDialog";

export default {
  name: "TranslationsItemActions",

  components: {
    ConfirmationDialog
  },

  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      fab: false
    };
  }
};
</script>




// WEBPACK FOOTER //
// src/components/gt/admin/languages/TranslationsItemActions.vue